import { ChevronLeft } from 'lucide-react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const SectionHeader = ({
  title,
  handleNext,
  handlePrev,
  showLeftButton,
  showRightButton,
  showViewAll
}) => {
  return (
    <div className="flex justify-between items-center w-full h-[12vh]">
      <h1 className="text-xl sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-bold">
        {title}
      </h1>
      <div className="flex gap-2 select-none">
        {!showViewAll && (showRightButton || showLeftButton) && (
          <div className="hidden lg:flex gap-2">
            <button
              onClick={handlePrev}
              className={`p-2 rounded-full border border-black ${
                showLeftButton ? "bg-charcoal hover:bg-hover-charcoal" : "bg-midnight"
              }`}
            >
              <ChevronLeft />
            </button>

            <button
              onClick={handleNext}
              className={`p-2 rounded-full border border-black ${
                showRightButton ? "bg-charcoal hover:bg-hover-charcoal" : "bg-midnight"
              }`}
            >
              <ChevronRight />
            </button>
          </div>
        )}
        {showViewAll && (
          <Link to="/genres" className="text-white text-xl font-medium hover:underline">
            View All
          </Link>
        )}
      </div>
    </div>
  );
};

export default SectionHeader;